import { List, Table, TextField, useTable } from '@pankod/refine-antd'
import { GetListResponse, IResourceComponentsProps } from '@pankod/refine-core'
import Head from 'next/head'
import React from 'react'

export const DasusProgramLocalManagementList: React.FC<
  IResourceComponentsProps<GetListResponse>
> = ({ options }) => {
  const { tableProps } = useTable({
    resource: 'local-programs',
    dataProviderName: 'lms',
  })

  return (
    <>
      <List title="LMS Program Local Management">
        <Head>
          <title>LMS Admin | {options?.label}</title>
        </Head>

        <Table {...tableProps} rowKey="id">
          <Table.Column
            dataIndex="id"
            title="ID"
            render={(value) => <TextField value={value} />}
          />
          <Table.Column
            dataIndex="slug"
            title="Slug"
            render={(value) => <TextField value={value} />}
          />
          <Table.Column
            dataIndex="name"
            title="Name"
            render={(value) => <TextField value={value} />}
          />
          {/* <Table.Column
            title="Actions"
            render={(_, record) => (
              <ShowProgramLocalButton
                size="small"
                recordItemId={record.id}
                programId={record.programId}
              />
            )}
          /> */}
        </Table>
      </List>
    </>
  )
}
